import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { getLibraryPageTokens } from '../getLibraryPageTokens';
import {
  LIBRARY_STATUS_FILTERS,
  type LibraryStatusFilterId,
} from '../libraryStatus';
import { LIBRARY_PAGE_LAYOUT_SIZES } from '../libraryTokens';

export interface LibraryStatusFilterBarProps {
  activeFilter: LibraryStatusFilterId;
  counts: Record<LibraryStatusFilterId, number>;
  onChange: (filterId: LibraryStatusFilterId) => void;
}

export function LibraryStatusFilterBar({
  activeFilter,
  counts,
  onChange,
}: LibraryStatusFilterBarProps): JSX.Element {
  const theme = useTheme();
  const tokens = getLibraryPageTokens(theme);

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: `${LIBRARY_PAGE_LAYOUT_SIZES.filterBarGap}px`,
      }}
    >
      {LIBRARY_STATUS_FILTERS.map((filter) => {
        const isActive = activeFilter === filter.id;
        const count = counts[filter.id];

        return (
          <Button
            key={filter.id}
            onClick={() => onChange(filter.id)}
            sx={{
              minHeight: `${LIBRARY_PAGE_LAYOUT_SIZES.filterPillHeight}px`,
              height: `${LIBRARY_PAGE_LAYOUT_SIZES.filterPillHeight}px`,
              px: 2,
              borderRadius: `${LIBRARY_PAGE_LAYOUT_SIZES.filterPillRadius}px`,
              textTransform: 'none',
              bgcolor: isActive ? tokens.filterPillActiveBg : tokens.filterPillInactiveBg,
              color: isActive ? tokens.filterPillActiveColor : tokens.filterPillInactiveColor,
              boxShadow: 'none',
              '&:hover': {
                bgcolor: isActive ? tokens.primaryButtonHoverBg : tokens.filterPillInactiveBg,
                boxShadow: 'none',
              },
            }}
          >
            <Typography component="span" sx={{ fontSize: '16px', fontWeight: 500, lineHeight: '24px' }}>
              {filter.label}
            </Typography>
            {filter.id === 'all' || count > 0 ? (
              <Typography
                component="span"
                sx={{
                  ml: 0.75,
                  fontSize: '14px',
                  fontWeight: 500,
                  opacity: tokens.filterPillCountOpacity,
                }}
              >
                {count}
              </Typography>
            ) : null}
          </Button>
        );
      })}
    </Box>
  );
}
